import {
  DebouncedTextInput,
  ReferenceCheckboxGroupInput,
  Toolbar,
} from "ra-friendsofbabba";
import { SimpleForm, required } from "react-admin";

import EquipmentsInput from "./inputs/EquipmentInput";
import React from "react";
import { useFieldLabel } from "ra-friendsofbabba";

const Form = (props) => {
  const fieldLabel = useFieldLabel({ ...props });
  return (
    <SimpleForm
      {...props}
      toolbar={
        <Toolbar
          backTab={2}
          backReference="executive-projects"
          backReferenceTarget="executive_project_id"
        />
      }
    >
      <EquipmentsInput
        source="equipment_type_id"
        validate={required()}
        fullWidth
      />
      <DebouncedTextInput
        maxLength={4000}
        source="description"
        validate={required()}
        fullWidth
        multiline
      />
      <ReferenceCheckboxGroupInput
        source="venue_types"
        reference="venue-types"
        optionText="name"
        validate={required()}
        label={fieldLabel("venue_types")}
        sort={{ field: "id", order: "ASC" }}
        fullWidth
      />
    </SimpleForm>
  );
};
export default Form;
